import React from "react";
import { TableRow, TableCell } from "@mui/material";

const ExciseServTableSummary = ({
  totals,
  tcs,
  grandTotal,
}: {
  totals: any;
  tcs: number;
  grandTotal: number;
}) => (
  <>
    {/* TCS Row */}
    <TableRow>
      <TableCell
        aria-labelledby="service-description"
        sx={{
          width: "50%",
          borderRight: "3px solid black",
          textAlign: "end",
          fontSize: "10px",
          borderBottom: "3px solid black",
          lineHeight: 2,
          "&.MuiTableCell-root.MuiTableCell-root": {
            paddingRight: "5px",
            fontFamily: "Inter",
          },
        }}
      >
        TCS @ 1%
      </TableCell>
      <TableCell
        aria-labelledby="unit-keg"
        colSpan={4}
        sx={{
          borderBottom: "3px solid black",
        }}
      />
      <TableCell
        aria-labelledby="amount"
        sx={{
          textAlign: "end",
          fontSize: "10px",
          borderBottom: "3px solid black",
          "&.MuiTableCell-root.MuiTableCell-root": {
            paddingRight: "10px",
            fontFamily: "Inter",
          },
        }}
      >
        {tcs.toFixed(2)}
      </TableCell>
    </TableRow>

    {/* Grand Total Row */}
    <TableRow>
      <TableCell
        aria-labelledby="service-description"
        sx={{
          width: "50%",
          borderRight: "3px solid black",
          textAlign: "end",
          fontSize: "10px",
          fontWeight: 600,
          lineHeight: 2,
          "&.MuiTableCell-root.MuiTableCell-root": {
            paddingRight: "5px",
            fontFamily: "Inter",
          },
        }}
      >
        Grand Total
      </TableCell>
      <TableCell aria-labelledby="unit-keg" colSpan={2} />
      <TableCell
        aria-labelledby="keg-nos"
        sx={{
          textAlign: "center",
          fontSize: "10px",
          fontWeight: 600,
          "&.MuiTableCell-root.MuiTableCell-root": {
            fontFamily: "Inter",
          },
        }}
      >
        {totals.totalKegNos}
      </TableCell>
      <TableCell
        aria-labelledby="litres"
        sx={{
          textAlign: "center",
          fontSize: "10px",
          fontWeight: 600,
          "&.MuiTableCell-root.MuiTableCell-root": {
            fontFamily: "Inter",
          },
        }}
      >
        {totals.totalLitres}
      </TableCell>
      <TableCell
        aria-labelledby="amount"
        sx={{
          textAlign: "end",
          fontSize: "10px",
          fontWeight: 600,
          "&.MuiTableCell-root.MuiTableCell-root": {
            paddingRight: "10px",
            fontFamily: "Inter",
          },
        }}
      >
        {grandTotal.toLocaleString()}
      </TableCell>
    </TableRow>
  </>
);

export default ExciseServTableSummary;
